module.exports = __webpack_public_path__ + "media/images/emblems/Baulmes-coat_of_arms-b6cda848ee2afadca2b2276adc29e578.svg";